import QuestionRating from "./QuestionRating";

export default QuestionRating;
